import { Link } from "react-router-dom";
import { Crown, ShieldCheck, Sparkles, UserRound } from "lucide-react";

export const ProChip = ({ className = "", testid }) => (
  <span className={`inline-flex items-center gap-1 rounded-full border border-[#F59E0B]/40 bg-[#F59E0B]/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.14em] text-[#FBBF24] ${className}`} data-testid={testid}>
    <Crown className="h-3 w-3" />Pro
  </span>
);

export const daysLeft = (iso) => {
  const d = Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86400000));
  return d === 1 ? "1 day left" : `${d} days left`;
};

export const PlanLinks = ({ user }) => {
  const plan = user?.plan || {};
  return (
    <div className="flex items-center gap-3">
      <Link to="/account" className="flex items-center gap-1.5 text-[#A8A090] transition-colors hover:text-[#F3EBDD]" data-testid="account-link">
        <UserRound className="h-4 w-4" />Account
      </Link>
      {plan.is_admin && (
        <Link to="/admin" className="flex items-center gap-1.5 text-[#A8A090] transition-colors hover:text-[#F3EBDD]" data-testid="admin-link">
          <ShieldCheck className="h-4 w-4" />Admin
        </Link>
      )}
      {plan.source === "event" ? (
        <Link to="/pricing" className="flex items-center gap-2" data-testid="plan-event-link">
          <ProChip />
          <span className="text-xs text-[#FBBF24]">Free for {plan.event?.name}</span>
        </Link>
      ) : plan.source === "trial" ? (
        <Link to="/pricing" className="flex items-center gap-2" data-testid="plan-trial-link">
          <ProChip />
          <span className="text-xs text-[#FBBF24]">Trial · {daysLeft(plan.trial_ends_at)}</span>
        </Link>
      ) : !plan.pro && plan.features?.length > 0 ? (
        <Link to="/pricing" className="flex items-center gap-2 text-xs text-[#FBBF24]" data-testid="plan-custom-link"><ProChip />Custom</Link>
      ) : plan.pro ? (
        <Link to="/pricing" data-testid="plan-pro-link"><ProChip /></Link>
      ) : (
        <Link to="/pricing" className="flex items-center gap-1.5 rounded-full bg-[#F59E0B] px-3 py-1 text-xs font-medium text-[#0B0D10] transition-transform hover:-translate-y-0.5" data-testid="upgrade-link">
          <Sparkles className="h-3.5 w-3.5" />Upgrade
        </Link>
      )}
    </div>
  );
};
